import type { ReactNode } from "react";
import { AppLink as Link } from "~/components/ui/app-link";

type AuthPageFooterProps = {
  label: ReactNode;
  to: string;
  prompt?: ReactNode;
};

export function AuthPageFooter({ label, to, prompt }: AuthPageFooterProps) {
  return (
    <div className="border-border/70 text-muted-foreground border-t pt-4 text-sm">
      {prompt ? (
        <>
          {prompt}{" "}
          <Link
            to={to}
            className="text-foreground font-medium underline underline-offset-4"
          >
            {label}
          </Link>
        </>
      ) : (
        <Link
          to={to}
          className="text-foreground font-medium underline underline-offset-4"
        >
          {label}
        </Link>
      )}
    </div>
  );
}
